import { render, staticRenderFns } from "./Bedrooms.vue?vue&type=template&id=b7d8ece6&lang=pug"
import script from "./Bedrooms.vue?vue&type=script&lang=js"
export * from "./Bedrooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports